<template>
    <div>
      <el-form class="toolbar" :inline="true">
        <el-form-item label="关键字">
          <el-input v-model="queryParams.Keyword" placeholder="请输入关键字" clearable></el-input>
        </el-form-item>
        <el-button type="primary" @click="listSearch" size="small">查询</el-button>
        <el-button type="success" icon="el-icon-plus" @click="toAdd" size="small">新增</el-button>
      </el-form>
      <paging-table ref="paging" :url="url.paging" :columns="columns" :queryParams="queryParams">
        <template slot="grid" slot-scope="grid" :data="grid.data">
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button class="button" type="text" @click="toEdit(scope.row)">
                修改
              </el-button>
              <el-button class="button" type="text" @click="toDelete(scope.row)">
                删除
              </el-button>
            </template>
          </el-table-column>
        </template>

      </paging-table>

      <!-- 新增弹框 -->
      <dialog-form :title="titleName" :formTemplate="formTemplate" :visible.sync="visible" :form="form" :rules="rules" :url="url.save" @saved="onSave()" style="width: 500px; margin: 0 auto;">
      </dialog-form>
    </div>
</template>

<script type="text/javascript">
  import PagingTable from '@/components/Table/PagingTable'
  import DialogForm from '@/components/Dialogs/DialogForm'
  import Template from "../../../components/template";
  export default {
    components: {
      Template,
      PagingTable,
      DialogForm
    },
    data() {
      return {
        columns: [
          {label: '车牌号', prop: 'CarNumber'},
          {label: '司机姓名', prop: 'DriverName'},
          {label: '司机身份证号', prop: 'DriverIDCard'},
          {label: '司机手机号', prop: 'DriverPhone'},
        ],
        url: {
          paging: SZH.assets.api + '/Custom/GetPagingCars',
          get: SZH.assets.api + '/Custom/GetCar',
          save: SZH.assets.api + '/Custom/SaveCar',
          del: SZH.assets.api + '/Custom/DeleteCar'
        },
        queryParams:{

        },
        formTemplate: [
          { col:24, label:'车牌号', prop:'CarNumber' ,default: ''},
          { col:24, label:'司机姓名', prop:'DriverName' ,default: ''},
          { col:24, label:'司机身份证号', prop:'DriverIDCard' ,default: ''},
          { col:24, label:'司机手机号', prop:'DriverPhone' ,default: ''},
        ],
        form: {
          CarNumber: null,
          DriverName: null,
          DriverIDCard: null,
          DriverPhone: null,
          Id:null,
          CustomId:null
        },
        rules:{
          CarNumber: [
            {
              required: true,
              message: '请输入车牌号',
              trigger: 'change'
            },
            {
              validator: validateCarNo,
              trigger: 'change'
            }
          ],
          DriverName: [
            {
              min: 2,
              max: 25,
              message: '姓名长度应在 2 到 25 个字符之间',
              trigger: 'blur'
            }
          ],
          DriverIDCard: [
            {
              required: true,
              message: '请输入证件号码',
              trigger: 'blur'
            },
            {
              validator: validateIdCard,
              trigger: 'blur'
            }
          ],
          DriverPhone: [
            {
              validator: validatePhone,
              trigger: 'blur'
            }
          ]
        },
        visible: false,
        titleName:'',
      }
    },
    created() {

    },
    mounted() {

    },
    methods: {
      reload() {
        this.$refs['paging'].reload();
      },
      // 查询
      listSearch(){
        this.$refs['paging'].reload();
      },
      // 新增
      toAdd(){
        this.visible = true;
        this.titleName = '新增'
      },
      // 修改
      toEdit(val){
        this.visible = true;
        this.titleName = '修改'
        let self = this;
        self.$http.post(self.url.get, { keyValue:val.Id}).then(result => {
          if(result.state == true && result.data != null){
            for (let i in self.form){
              for (let j in result.data){
                if(i === j){
                  self.form[i] = result.data[j]
                }
              }
              // if(result.data.Data[i] != undefined){
              //   self.form[i] = result.data.Data[i]
              // }else {
              //   self.form[i] = null;
              // }
            }
          } else {

          }
        }, () => {
        });
      },
      // 保存
      onSave() {
        this.$message.success('车辆信息'+this.titleName+'成功！');
        this.$refs['paging'].reload();
      },
      // 删除
      toDelete(val){
        var self = this;
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          self.$http.post(self.url.del, { keyValue:val.Id}).then(result => {
            if(result.state == true){
              this.$refs['paging'].reload();
              this.$message({
                type: 'success',
                message: result.message
              });
            }else{
              this.$message({
                type: 'error',
                message: result.message
              });
            }
          }, () => {
          });
        }).catch(() => {

        });

      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Me/Cars/Cars.vue